import React from 'react';
import { Container } from '../../components/ui/Container';
export function PrivacyPolicy() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3872" data-mp="v5clzvmeidou">
        <Container data-id="element-3873" data-mp="v49v3np2wb8x">
          <div className="max-w-4xl mx-auto" data-id="element-3874" data-mp="19vabcew2h9fm">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3875" data-mp="19tz1pyfxx7gl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3876" data-mp="14yjp19to5hlr">
              <strong data-id="element-3877" data-mp="h7o0qmof94j9">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3878" data-mp="c81mqb0rrk9e">
              <p data-id="element-3879" data-mp="c9uvpwyuugkk">
                The <strong data-id="element-3880" data-mp="q7sv9w8io8g0">International Islamic Learning Hub (IILH)</strong>{' '}
                is deeply committed to protecting your privacy and ensuring the
                security of your personal data.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3881" data-mp="21lexahzh64iy">
                Data Collection
              </h2>
              <p data-id="element-3882" data-mp="1xmxntrsl0hyd">
                We collect personal data necessary to provide our services,
                including but not limited to:
              </p>
              <p data-id="element-3883" data-mp="rc646w6uk23l">
                <strong data-id="element-3884" data-mp="rbnxf5mk65hf">• Identity Data:</strong> Name and contact details
                (email, phone number, address).
              </p>
              <p data-id="element-3885" data-mp="10dx75ta05utr">
                <strong data-id="element-3886" data-mp="10efdxjuajrfx">• Account Data:</strong> Username, password, and
                membership status.
              </p>
              <p data-id="element-3887" data-mp="3oo6kk0wi9sp">
                <strong data-id="element-3888" data-mp="3p7r88hxrcaf">• Service Data:</strong> Information submitted through
                applications and inquiries.
              </p>
              <p data-id="element-3889" data-mp="cobb3eoxfvpz">
                <strong data-id="element-3890" data-mp="cnt4bo4n1z3t">• Financial Data:</strong> Payment-related information,
                which is processed securely via third-party payment providers.
                We do not store sensitive credit card details on our servers.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3891" data-mp="3g2yxbr9y9bve">
                How We Use Your Data
              </h2>
              <p data-id="element-3892" data-mp="s94hz49q9tto">Your data is used for the following specific purposes:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3893" data-mp="s7be1wqi1npd">
                <li data-id="element-3894" data-mp="na1maafn0zyd">To deliver educational programs and community services.</li>
                <li data-id="element-3895" data-mp="110obnbziddhs">
                  To communicate with you regarding updates, coursework, or
                  administrative notices.
                </li>
                <li data-id="element-3896" data-mp="9aihnrm1c6qt">To fulfill our legal and administrative obligations.</li>
                <li data-id="element-3897" data-mp="9cwd41kmnkyw">
                  To analyze trends and improve the quality of our services.
                </li>
              </ul>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3898" data-mp="ibzxd8vj66ez">
                Data Protection and Sharing
              </h2>
              <p data-id="element-3899" data-mp="db2eeu2p58cf">
                <strong data-id="element-3900" data-mp="deq7xt855ur5">Security:</strong> We process all data lawfully and
                utilize appropriate technical measures to ensure security.
              </p>
              <p data-id="element-3901" data-mp="1or0qz7x32cie">
                <strong data-id="element-3902" data-mp="1otmxr5c5gnzk">No Sale of Data:</strong> We do not sell, rent, or
                misuse your personal data for commercial gain.
              </p>
              <p data-id="element-3903" data-mp="21aei0ui8hbz9">
                <strong data-id="element-3904" data-mp="21axuvwt11a6f">Access Control:</strong> Access to personal information
                is strictly restricted to authorized personnel who require it to
                perform their duties.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3905" data-mp="1s9q5634kthny">
                GDPR Compliance and User Rights
              </h2>
              <p data-id="element-3906" data-mp="2kynevhuq2653">In accordance with GDPR standards, you have the right to:</p>
              <p data-id="element-3907" data-mp="26990twg7b0jd">
                <strong data-id="element-3908" data-mp="269r7ln0hox5j">• Access:</strong> Request a copy of the personal data
                we hold about you.
              </p>
              <p data-id="element-3909" data-mp="2b711beuwvuz6">
                <strong data-id="element-3910" data-mp="2b6hi7utiz0jk">• Rectification and Erasure:</strong> Request correction
                of inaccurate data or deletion of your data ("Right to be
                Forgotten").
              </p>
              <p data-id="element-3911" data-mp="33py3fscz66tt">
                <strong data-id="element-3912" data-mp="33qg2ewr0uz5f">• Withdraw Consent:</strong> Withdraw your consent for
                data processing at any time, where applicable.
              </p>
              <p data-id="element-3913" data-mp="1b0fdv7r0ycyr">
                To exercise these rights, please contact our Data Protection
                Officer at:{' '}
                <a href="mailto:privacy@iilh.org" className="text-forest-700 underline hover:text-forest-800" data-id="element-3914" data-mp="1648btq1r1lm3">
                  privacy@iilh.org
                </a>
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}